import { ErrorMessage } from '../../types/main';

export const WIFI_THERMOSTATS_REQUEST = 'WIFI_THERMOSTATS_REQUEST';
export const WIFI_THERMOSTATS_REQUEST_SUCCESS = 'WIFI_THERMOSTATS_REQUEST_SUCCESS';
export const WIFI_THERMOSTATS_REQUEST_FAILED = 'WIFI_THERMOSTATS_REQUEST_FAILED';

// Define action types here instead of importing from actions to avoid circular dependency
export type WifiThermostatsRequestAction = {
  type: typeof WIFI_THERMOSTATS_REQUEST;
  payload?: any;
};

export type WifiThermostatsRequestSuccessAction = {
  type: typeof WIFI_THERMOSTATS_REQUEST_SUCCESS;
  payload: WifiThermostat[];
};

export type WifiThermostatsRequestFailedAction = {
  type: typeof WIFI_THERMOSTATS_REQUEST_FAILED;
  payload: ErrorMessage;
};

export type WifiThermostatsActionsTypes =
  | WifiThermostatsRequestAction
  | WifiThermostatsRequestSuccessAction
  | WifiThermostatsRequestFailedAction;

export interface WifiSeamThermostat {
  token: {
    client_session_id: string;
    created_at: string;
    user_identifier_key: string;
    token: string;
    workspace_id: string;
  }
}

export interface WifiThermostat {
  serial_number: string
  wifi_thermostat_serial_number: string
  property_id: string
  address_1: string
  house_num: string
  community_name: string
  community_id: string
}

export type WifiThermostatsRequestSuccess = WifiThermostat[];

export type WifiThermostatsState = {
  items: WifiThermostat[];
  loading: boolean;
  refreshing: boolean;
  error: ErrorMessage['message'];
  selected: WifiThermostat | null;
};
